import Head from 'next/head';

const SeoNoticiasFlash = ({ title, url, description, author, date, image }) => {
    return (
        <Head>
            <title>{title}</title>
            <link rel="canonical" href={url} key="canonical" />
            <meta name="description" content={description} key="name-description" />
            <meta property="og:url" content={url} key="url" />
            <meta property="og:title" content={title} key="title" />
            <meta property="og:description" content={description} key="description" />
            <meta property="og:image:secure_url" content={image} key="image" />
            <meta name="viewport" content="initial-scale=1.0, width=device-width" key="viewport" />
            <meta name="author" content={author ?? 'Analítica Fantasy'} />
            <meta name="date" content={date ?? new Date()} />
            <meta property="og:image:width" content="250" />
            <meta property="og:image:height" content="250" />
            <meta name="twitter:card" content="summary" key="twitter-card" />
            <meta name="twitter:image:alt" content="analítica fantasy" key="twitter-card-image-alt" />
            <meta name="twitter:site" content="https://www.analiticafantasy.com" key="website" />
            <meta name="twitter:site:id" content="@AnaliticaLaLiga" key="website-twitter" />
            <meta name="twitter:creator" content="@AnaliticaLaLiga" key="twitter-creator" />
            <meta name="twitter:image" content={image} key="twitter-image" />
            <meta name="twitter:image:src" content={image} key="twitter-image" />
            <meta name="twitter:title" content={title} key="twitter-title" />
            <meta name="twitter:description" content={description} key="twitter-description" />
            <meta
                name="keywords"
                content="Noticias, fútbol, fantasy, alineaciones probables, entrenamiento, lesionados, rueda de prensa, rotaciones"
            />
            <meta name="article:section" content="Fútbol" />
            <meta name="article:tag" content="Fantasy, Fútbol, Deporte" />
        </Head>
    );
};

export default SeoNoticiasFlash;
